import React from 'react'
import { Link, browserHistory } from 'react-router'
import classes from './GameList.scss'
import GameItem from './GameItem'
import NewChallengeModal from '../Modals/NewChallengeModal'
import ViewChallengeModal from '../Modals/ViewChallengeModal'

class Challenges extends React.Component {

  constructor (props) {
    super(props)

    const self: any = this
    self.state = { challenges: [], sentChallenges: [], loadingNew: false, loadingOld: false }
    self.newChallenge = self.newChallenge.bind(self)
    self.renderChallenges = self.renderChallenges.bind(self)
    self.renderChallenge = self.renderChallenge.bind(self)
    self.fetchChallenges = self.fetchChallenges.bind(self)
    self.loadSentChallenges = self.loadSentChallenges.bind(self)
  }

  componentWillMount () {
    const { baseUrl } = this.props
    this.fetchChallenges(baseUrl)
  }

  componentWillReceiveProps (nextProps) {
    const { baseUrl } = nextProps
    this.fetchChallenges(baseUrl)
  }

  fetchChallenges (baseUrl) {
    this.setState({ loadingNew: true })
    fetch(`${baseUrl}/challenges`, {
      method: 'POST',
      body: JSON.stringify({ type: 'in' }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          this.setState({ challenges: res.challenges })
        } else {
          // alert(res.err || res.message || res.msg)
        }
        this.setState({ loadingNew: false })
      })
  }

  loadSentChallenges () {
    const { baseUrl, type } = this.props

    this.setState({ loadingOld: true })
    fetch(`${baseUrl}/challenges`, {
      method: 'POST',
      body: JSON.stringify({ type: 'out' }),
      credentials: 'include',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          this.setState({ sentChallenges: res.challenges })
        } else {
          // console.log(res)
          // alert(res.err || res.message || res.msg)
        }
        this.setState({ loadingOld: false })
      })
  }

  newChallenge () {
    const { username } = this.props
    if (username) {
      browserHistory.push('/challenges/new')
    } else {
      alert('You must be logged in to issue a challenge')
    }
  }

  renderChallenge (challenge, idx, click) {
    const { baseUrl, openViewChallengeModal } = this.props
    const onClick = click && (() => openViewChallengeModal(challenge.id))
    return (
      <GameItem key={idx} id={challenge.id} first={challenge.sender} second={challenge.timeAgo} baseUrl={baseUrl} onClick={onClick} />
    )
  }

  renderChallenges (challenges, click=true) {
    return challenges.map((c, i) => this.renderChallenge(c, i, click))
  }

  render () {
    const { baseUrl, username, challengeModal, closeChallengeModal,
            viewChallengeModal, closeViewChallengeModal, openAlertModal } = this.props
    const { challenges, sentChallenges, loadingNew, loadingOld } = this.state
    const challenge = challenges.find(c => c.id === viewChallengeModal)
    const sender = challenge && challenge.sender

    return (
      <div>
        {username && <ul className={classes.headers}>
          <li>From</li>
          <li>Received at</li>
        </ul>}
        {!loadingNew && username && challenges.length < 1 && <h3 className={classes.emptyText}>No challenges :(</h3>}
        {!username && <h3 className={classes.emptyText}>You must be <Link to='/' style={{borderBottom: '1px solid #fff', paddingBottom: '0.1px'}}>logged in</Link> to receive challenges</h3>}
        {username && loadingNew && <h3 className={classes.loading}>Loading...</h3>}
        <ul className={classes.gameItems}>{this.renderChallenges(challenges)}</ul>
        <span onClick={this.newChallenge} className={classes.newGame}><i className="fa fa-plus-square" aria-hidden="true"></i>New Challenge</span>
        {challengeModal && <NewChallengeModal baseUrl={baseUrl} closeChallengeModal={closeChallengeModal} openAlertModal={openAlertModal} />}
        {viewChallengeModal && <ViewChallengeModal challengeId={viewChallengeModal} baseUrl={baseUrl} sender={sender} closeViewChallengeModal={closeViewChallengeModal} />}
        {!loadingOld && sentChallenges.length === 0 && <p className={classes.viewOld} onClick={this.loadSentChallenges}>View sent challenges</p>}
        {loadingOld && <h3 className={classes.loading}>Loading...</h3>}
        {sentChallenges.length > 0 && <ul className={classes.headers}><li>To</li><li>Sent at</li></ul>}
        <ul className={classes.gameItems}>{this.renderChallenges(sentChallenges, false)}</ul>
      </div>

    )
  }
}

export default Challenges



/** WEBPACK FOOTER **
 ** ./src/components/GameList/Challenges.js
 **/